import type { Column } from '@tanstack/react-table';
import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

type DataTableColumnHeaderProps<TData, TValue> = {
    column: Column<TData, TValue>;
    title: string;
};

export function DataTableColumnHeader<TData, TValue>({ column, title }: DataTableColumnHeaderProps<TData, TValue>) {
    if (!column.getCanSort()) {
        return <span>{title}</span>;
    }

    return (
        <Button
            type="button"
            variant="ghost"
            size="sm"
            className={cn('-ml-2 h-8 data-[state=open]:bg-accent', column.getIsSorted() && 'text-primary')}
            onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
            {title}
            {column.getIsSorted() === 'desc' ? (
                <ArrowDown className="ml-1 size-3.5" />
            ) : column.getIsSorted() === 'asc' ? (
                <ArrowUp className="ml-1 size-3.5" />
            ) : (
                <ChevronsUpDown className="ml-1 size-3.5" />
            )}
        </Button>
    );
}
